import FacebookLikeButtonEditor from '@intercom/embercom-composer/components/facebook-like-button-editor';
export default FacebookLikeButtonEditor;
